import { getColorModePreference, getSystemColorMode } from './util/colorModePreference';
import { applyInitialColorMode } from './util/initialColorMode';

applyInitialColorMode({
    preference: getColorModePreference(),
    systemColorMode: getSystemColorMode()
});
